"use client";
import React, { createContext, useState, useEffect, useCallback } from "react";
import i18n from "./i18n";
import { useLanguageStorage } from "@store/i18nstore";
import dayjs from "dayjs";


export const LanguageContext = createContext({
  language: "",
  changeLanguage: (lang: string) => { },
});

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const languageStore = useLanguageStorage();
  const [language, setLanguage] = useState(languageStore.language);

  const updateDayjsLocale = (lang: string) => {
    try {
      dayjs.locale(lang); // Mengatur locale di dayjs sesuai bahasa yang dipilih
    } catch (error) {
      console.warn(`Locale ${lang} tidak ditemukan untuk dayjs.`);
    }
  };

  // Load language from Zustand and sync with i18n on mount
  useEffect(() => {
    if (languageStore.language) {
      setLanguage(languageStore.language);
      i18n.changeLanguage(languageStore.language);
      updateDayjsLocale(languageStore.language);
    }
  }, [languageStore.language]); // Trigger when Zustand state changes

  // Update Zustand and i18n when language changes
  const changeLanguage = useCallback((lang: string) => {
    setLanguage(lang);
    languageStore.changeLanguage(lang);
    i18n.changeLanguage(lang);
    updateDayjsLocale(languageStore.language);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};